import type { FormFieldConfig } from './types';

/**
 * Whether a standard (registry-declared) field may be the target of a
 * conditional-visibility rule in the form editor.
 *
 * A field carrying a code-declared `defaultConditions` is a target by
 * definition: the editor seeds that default into the field's editor state,
 * which lights the condition icon on the field row. Treating such a field as
 * ineligible hid the whole Conditional logic section while leaving the icon on,
 * so the row advertised a condition the editor then refused to show (RSP-6848).
 *
 * An explicit `allowTargetConditions: false` still wins, so a field can opt out
 * even while declaring a default.
 */
export const standardFieldAllowsTargetConditions = (
  field:
    | Pick<FormFieldConfig, 'allowTargetConditions' | 'defaultConditions'>
    | undefined
): boolean => field?.allowTargetConditions ?? !!field?.defaultConditions;
